import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { PublicLayout } from './PublicLayout';

export default function ContactPage() {
    return (
        <PublicLayout>
            <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16" data-testid="contact-page">
                <div className="text-center mb-12">
                    <div className="text-xs uppercase tracking-wider text-primary font-semibold mb-2">Contact</div>
                    <h1 className="font-heading text-4xl sm:text-5xl mb-4" data-testid="contact-title">
                        We reply the same day.
                    </h1>
                    <p className="text-muted-foreground max-w-lg mx-auto">
                        Questions about pricing, features, or something not working? Reach out — we usually reply the same day.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-4">
                    <ContactCard
                        icon={<Mail size={22} />}
                        title="Email"
                        primary="support@easemybill.com"
                        subtitle="Best for detailed questions, refunds, GST queries."
                        href="mailto:support@easemybill.com"
                        testid="contact-card-email"
                    />
                    <ContactCard
                        icon={<Phone size={22} />}
                        title="Phone"
                        primary="+91 97991 19994"
                        subtitle="Mon–Sat, 10 AM – 7 PM IST. Call or WhatsApp."
                        href="tel:+919799119994"
                        testid="contact-card-phone"
                    />
                    <ContactCard
                        icon={<Clock size={22} />}
                        title="Business hours"
                        primary="Mon–Sat, 10 AM – 7 PM IST"
                        subtitle="Emails sent outside these hours are picked up next working morning."
                        testid="contact-card-hours"
                    />
                </div>

                <div className="mt-10 rounded-2xl border border-border/60 bg-muted/30 p-6 sm:p-8 flex items-start gap-4" data-testid="contact-address">
                    <div className="h-10 w-10 rounded-lg bg-primary/10 text-primary grid place-items-center flex-shrink-0">
                        <MapPin size={20} />
                    </div>
                    <div>
                        <div className="font-heading text-lg mb-1">Ease My Bill</div>
                        <div className="text-sm text-muted-foreground">
                            37 Vijay Chowk, Inside Nagori Gate<br />
                            Jodhpur, Rajasthan – 342001<br />
                            India
                        </div>
                        <div className="text-xs text-muted-foreground mt-3">
                            PAN: <span className="font-mono">BYNPD9659J</span>
                        </div>
                        <div className="text-xs text-muted-foreground mt-2">
                            For grievances, please email <a href="mailto:support@easemybill.com" className="text-primary hover:underline">support@easemybill.com</a> with the subject line "Grievance". We aim to respond within 7 business days.
                        </div>
                    </div>
                </div>

                <div className="mt-12 text-center text-sm text-muted-foreground">
                    Not ready to reach out?{' '}
                    <a href="/pricing" className="text-primary hover:underline">See pricing</a> or{' '}
                    <a href="/login?tab=signup" className="text-primary hover:underline">start your free trial</a>.
                </div>
            </div>
        </PublicLayout>
    );
}

function ContactCard({ icon, title, primary, subtitle, href, testid }) {
    const Wrapper = href ? 'a' : 'div';
    return (
        <Wrapper
            href={href}
            className={`block rounded-xl border border-border/70 bg-background p-5 ${href ? 'hover:border-primary/40 hover:shadow-sm' : ''} transition-all`}
            data-testid={testid}
        >
            <div className="h-10 w-10 rounded-lg bg-primary/10 text-primary grid place-items-center mb-3">
                {icon}
            </div>
            <div className="font-heading text-lg mb-1">{title}</div>
            <div className="text-sm text-foreground mb-1">{primary}</div>
            <div className="text-xs text-muted-foreground leading-relaxed">{subtitle}</div>
        </Wrapper>
    );
}
